
export const REPORT_EARNING_REQUESTED = 'REPORT_EARNING_REQUESTED';
export const REPORT_EARNING_SUCCEED = 'REPORT_EARNING_SUCCEED';
export const REPORT_EARNING_FAILED = 'REPORT_EARNING_FAILED';

export const REPORT_EARNING_CLINIC_REQUESTED = 'REPORT_EARNING_CLINIC_REQUESTED';
export const REPORT_EARNING_CLINIC_SUCCEED = 'REPORT_EARNING_CLINIC_SUCCEED';
export const REPORT_EARNING_CLINIC_FAILED = 'REPORT_EARNING_CLINIC_FAILED';
